import { useAppSelector } from "hooks/redux"
import { useDashboardId } from "../context/dashboard-id"

// Reads directly from state.dashboard.model[dashboardId] — does not subscribe
// to DashboardContext, so model changes do not re-render unrelated consumers.
export function useModelId(): string | null {
  const dashboardId = useDashboardId()
  return useAppSelector((s) => s.dashboard.model[dashboardId]?.modelId ?? null)
}
